import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    description: 'Automation rules header',
    defaultMessage: 'Automation Rules',
    id: 'mTIhfU',
  },
  subheader: {
    description: 'Automation rules subheader',
    defaultMessage:
      'Automation rules help you perform tasks for all aspects of your workflow. You can manage your rules below or create a new one.',
    id: '40nVjg',
  },
  learnMoreAboutAutomationRules: {
    description: 'Link to learn more about automation rules',
    defaultMessage: 'Learn more about Automation Rules',
    id: '71OQwR',
  },
  reprocessCopy: {
    description: 'Copy above reproces button',
    defaultMessage:
      'To apply recent changes to product details, store mappings or automation rules to your current open orders, click <b>Reprocess Automation Rules</b> below. <b>Warning:</b> This may overwrite any shipping settings that have been made since the orders were imported.',
    id: 'NMlcqj',
  },
  edit: {
    description: 'Automation edit button',
    defaultMessage: 'Edit',
    id: 'yD2rM/',
  },
  copyButton: {
    description: 'button text for the copy action',
    defaultMessage: 'Copy',
    id: 'QJHxtY',
  },
  copiedRuleName: {
    description: 'the name of the copied rule plus "Copy" to indicate to the user it is a copy',
    defaultMessage: '{name} Copy',
    id: 'oRfGz+',
  },
  delete: {
    description: 'Automation delete button',
    defaultMessage: 'Delete',
    id: 'kmWXAF',
  },
  createARule: {
    description: 'Automation create a rule button',
    defaultMessage: 'Create a Rule',
    id: '7NkdN4',
  },
  reprocessAutomationRules: {
    description: 'Automation reprocess button',
    defaultMessage: 'Reprocess Automation Rules',
    id: '3eEieQ',
  },
  ruleName: {
    description: 'Automation rule name header',
    defaultMessage: 'Rule Name',
    id: 'Ha8KKQ',
  },
  lastModified: {
    description: 'Automation last modified header',
    defaultMessage: 'Last Modified',
    id: 'clZB4J',
  },
  active: {
    description: 'Automation active header',
    defaultMessage: 'Active',
    id: 'rGBolH',
  },
  actions: {
    description: 'Automation actions header',
    defaultMessage: 'Actions',
    id: 'uxz0HP',
  },
  failedToFetch: {
    description: 'Failed to fetch automation rules',
    defaultMessage: 'Failed to fetch Automation Rules',
    id: 'KUQi1Z',
  },
  failedToDelete: {
    description: 'Failed to delete automation rule',
    defaultMessage: 'Failed to delete Automation Rule, please try again',
    id: 'oP4nMa',
  },
  failedToReorder: {
    description: 'Failed to re-order rules',
    defaultMessage: 'Failed to reorder Automation Rules, please try again',
    id: 'icE9Gn',
  },
  failedToFindMatchingRule: {
    description: 'Failed to find matching rule',
    defaultMessage: 'Failed to find matching rule, please refresh and try again',
    id: 'SsMya0',
  },
  failedToUpdate: {
    description: 'Failed to update automation rule active state',
    defaultMessage: 'Failed to update Automation Rule, please try again',
    id: 'WbN58x',
  },
  dragInstructions: {
    description: 'Instructions for drag and drop reorder',
    defaultMessage: 'Sequence the order in which automation rules are run by dragging them to the desired location',
    id: 'ck5vUo',
  },
  deleteAutomationRule: {
    description: 'Delete modal header',
    defaultMessage: 'Delete Automation Rule',
    id: '/uszn9',
  },
  deleteAutomationRuleConfirmation: {
    description: 'Confirmation text to delete automation rule',
    defaultMessage: 'Are you sure you want to delete the following automation rule?',
    id: 'FgvK52',
  },
  save: {
    description: 'Save things in automation rules',
    defaultMessage: 'Save',
    id: 'I5Hc1s',
  },
  cancel: {
    description: 'Cancel things in automation rules',
    defaultMessage: 'Cancel',
    id: 'HeGDZN',
  },
  excludedCarriersInfoBanner: {
    description: 'banner to let users know some carriers may not be supported for automation rules',
    defaultMessage: 'Some automation rules may not apply to orders from selling channels that provide labels. <a>Learn more</a>',
    id: 'bKQuon',
  },
  showInactiveLabel: {
    description: 'Show Inactive Label',
    defaultMessage: 'Show Inactive',
    id: '0qJpLw',
  },
  dragToReorder: {
    description: 'Tooltip text for drag and drop reorder',
    defaultMessage: 'Drag to change the execution order of your automation rules',
    id: 'fJ/XyC',
  },
  orderImportTab: {
    description: 'Tab label for the Order Import automation rules tab',
    defaultMessage: 'Order Import',
    id: 'BBzSrN',
  },
  workflowsTab: {
    description: 'Tab label for the Workflows tab in Automation Rules',
    defaultMessage: 'Workflows',
    id: '/FSteW',
  },
});
